import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import httpClient from "../../../api/httpClient";
import { useDispatch } from "react-redux";
import { getMe } from "../../../store/user/thunks";
import { StyledLayout } from "./styles";
import SideBar from "./SideBar";
import { useWebSocket } from "../../../hooks/useWebSocket";
import { requestNotificationPermission } from "../../../utils/notificationService";
import { Grid } from "antd";
import BottomNavigation from "./BottomNavigation";

const { useBreakpoint } = Grid;

const AppLayout = () => {
  const { md } = useBreakpoint();
  const dispatch = useDispatch();

  useWebSocket(true);
  const acesstoken = httpClient.getAccessToken();

  useEffect(() => {
    if (acesstoken) dispatch(getMe());
    requestNotificationPermission();
  }, []);

  useEffect(() => {
    if (!acesstoken) httpClient.redirectToLogin();
  }, [acesstoken]);

  return (
    <>
      {acesstoken && (
        <StyledLayout>
          {md && <SideBar />}
          <div
            className="w-100 main-content-div"
            style={{ background: "#f9fafb" }}
          >
            <Outlet />
          </div>
          {!md && <BottomNavigation  />}
        </StyledLayout>
      )}
    </>
  );
};

export default AppLayout;
